// Generate code from clean architecture template

import { QueryCourseLinePayload, QueryCourseLinesOutput } from '../ports/payloads';
import { CourseLineRepository } from '../ports/repositories';

export class GetListCourseLineUsecase {
  constructor(private readonly repo: CourseLineRepository) {}

  async run(payload?: QueryCourseLinePayload): Promise<QueryCourseLinesOutput> {
    const data = await this.repo.getListCourseLine(payload);
    return data;
  }
}
